<div class="confirm-modal"
     id="confirm-modal-id"
     tabindex="-1"
     role="dialog"
     aria-hidden="true"
     *ngIf="showDialog">
  <div class="modal-dialog confirm-modal__confirm-dialog"
       role="document">
    <div class="modal-content confirm-modal__confirm-dialog__confirm-content">
      <div class="modal-header confirm-modal__confirm-dialog__confirm-content__confirm-header">
        <h4 id="confirmModalLabel">
          {{'components.confirmDialogComponent.title' | translate}}
        </h4>
      </div>
      <div class="modal-body font-weight-bold confirm-modal__confirm-dialog__confirm-content__confirm-body">
        <span class="fa fa-exclamation" aria-hidden="true"></span>
        <label>{{bodyMessage | translate}}</label>
      </div>
      <div class="modal-footer confirm-modal__confirm-dialog__confirm-content__confirm-footer">
        <button type="button"
                class="btn btn-default"
                (click)="confirmed()"
                data-dismiss="modal">
          <span class="fa fa-check"></span>
          <span>{{'components.confirmDialogComponent.save' | translate}}</span>
        </button>
        <button type="button"
                class="btn btn-default"
                (click)="cancel()"
                data-dismiss="modal">
          <span class="fa fa-times"></span>
          <span>{{'components.confirmDialogComponent.cancel' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
